import React, { Component, Fragment } from 'react'
import ApiService from '../modules/ApiService';
import withAuth from '../components/withAuth';
import TopBar from '../components/TopBar';
import { withStyles, Container, List, ListItem, ListItemText, RootRef, Portal, Paper, Grid, CardContent, Card, CardHeader, Typography, IconButton, Button, ListItemIcon, ListItemSecondaryAction, Icon, Fab, Tooltip, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Divider, DialogContentText, Avatar, Slider, LinearProgress } from '@material-ui/core';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Edit, Delete, Close, Add, ArrowDownward, CloudUpload, AddCircle, Description, Folder } from '@material-ui/icons';
import { thisTypeAnnotation } from '@babel/types';
import GoogleDriveApi from '../modules/googledriveapi';
import htmlTransformer from '../modules/htmlTransformer';

const styles = theme => ({
    disciplineTitle: {
        //backgroundColor: "white",
        marginTop: theme.spacing(4)
    },
    specialtyList: {
        //backgroundColor: "gray",
        marginTop: theme.spacing(4),

    },
    baseList: {
        //backgroundColor: "darkGreen",
        marginTop: theme.spacing(4)
    },
    mainContainer: {
        //backgroundColor: "darkblue",
        flexGrow: 1
    },
});

function PortalAwareDraggable({ provided, snapshot, children }) {
    return snapshot.isDragging ? <Portal>{children}</Portal> : children;
}




class BaseEditorDiscipline extends Component {

    constructor(props) {
        super(props)
        this.api = new ApiService();
        this.googleapi = new GoogleDriveApi()
        this.state = { 
            specialties: [], 
            baseList: [],
            createBaseDialogIsOpen: false, 
            uploadFileDialogIsOpen: false, 
            previewDialog: false, 
            fileLoading: false, 
            generating: false, 
            currentQuestion: null,
            loaderText: ''
        }
        this.disciplineid = props.match.params.disciplineid
        this.languageid = props.match.params.languageid
        this.baseid = 0
        this.currentQuestion = null
    }

    componentWillMount() {

        if (isNaN(this.disciplineid) || isNaN(this.languageid)) {
            this.props.history.replace('/editor');
            return
        }

        if (!this.api.loggedIn()) {
            this.props.history.replace('/login');
            return
        }

        if (this.props.user.AccessLevel == 3) {
            if (!this.props.user.AllowedDisciplines.split(',').includes(this.disciplineid + '-' + this.languageid)) {
                this.props.history.replace('/editor');
                return
            }
        }

        this.getSpecialtyList()
        this.getBaseList()

    }

    render() {
        console.log(this.state.baseList);
        const classes = this.props.classes;
        const { location } = this.props;
        return (
            <Fragment>

                <TopBar {...this.props} title={location.state ? location.state.name : "NONAME"} />
                {/* <div className={classes.disciplineTitle}>
                    <h2 style={{ textAlign: "left", marginLeft: "32px" }}></h2>
                 </div> */}
                <Fragment>
                    <DragDropContext onDragEnd={this.onDragEnd(this)}>
                        <Container maxWidth={false} className={classes.mainContainer}>
                            <Grid container spacing={0}>

                                <Grid item xs={3}>



                                    {/* <div style={{ width: "100%", backgroundColor: "rgb(235, 236, 240)" }}> */}
                                    <Container maxWidth="xs" className={classes.specialtyList}>
                                        <h2>{"Нераспределенные специальности"}</h2>


                                        <Droppable droppableId="droppable">
                                            {(provided, snapshot) =>
                                                (<RootRef rootRef={provided.innerRef}>
                                                    <List >
                                                        {this.state.specialties.map((specialty, index) => {
                                                            return (

                                                                <Draggable key={specialty.SpecialtyID.toString()} draggableId={specialty.SpecialtyID.toString()} index={index}>
                                                                    {
                                                                        (provided, snapshot) => (
                                                                            <PortalAwareDraggable
                                                                                snapshot={snapshot}
                                                                                provided={provided}
                                                                            >

                                                                                <div ref={provided.innerRef} {...provided.draggableProps}{...provided.dragHandleProps}>
                                                                                    <div style={{ paddingTop: "10px", paddingBottom: "10px" }}  >
                                                                                        <Paper >
                                                                                            <ListItem style={{ overflow: "hidden", whiteSpace: "normal", textOverflow: "ellipsis" }}>
                                                                                                <ListItemText
                                                                                                    primary={specialty.SpecialtyName}
                                                                                                    secondary={specialty.SpecialtyCode}
                                                                                                />

                                                                                            </ListItem>
                                                                                        </Paper>
                                                                                    </div>
                                                                                </div>


                                                                            </PortalAwareDraggable>
                                                                        )
                                                                    }


                                                                </Draggable>
                                                            )
                                                        })
                                                        }
                                                    </List>
                                                    {provided.placeholder}
                                                </RootRef>)
                                            }
                                        </Droppable>

                                    </Container>
                                    {/* </Paper> */}
                                </Grid>
                                <Grid item xs={8}>
                                    {/* <Paper style={{ width: "100%", marginLeft: "10px" }}> */}


                                    <Container className={classes.baseList}>

                                        <div style={{ flexGrow: 1, height: "82px" }}>
                                            <h2 style={{ flexGrow: 1 }}>
                                                <span>{"Базы вопросов"}
                                                    <Tooltip placement="right" title={"Создать базу вопросов"}>
                                                        <Fab style={{ marginLeft: "10px", marginTop: "-2px" }} variant="extended" size="small" onClick={this.createBaseDialogOpen(this)}><Add /></Fab>
                                                    </Tooltip>
                                                </span>
                                            </h2>
                                        </div>


                                        <Grid container spacing={2}>
                                            {this.state.baseList.map(base => {
                                                return (
                                                    <Grid item xs={4}>
                                                        <Card style={{ backgroundColor: "rgb(235, 236, 240)" }}>
                                                            <List>
                                                                <ListItem style={{ overflow: "hidden", whiteSpace: "normal", textOverflow: "ellipsis" }} divider={false}>

                                                                    <ListItemText primary={base.content.baseName} />

                                                                    <ListItemSecondaryAction>
                                                                        <Tooltip placement="top" title={base.content.creator.name}>
                                                                            <IconButton size="small">
                                                                                <Avatar src={'https://www.do.ektu.kz/PReports/Cards/EmployeePhoto.asp?EmployeeID=' + base.content.creator.id} />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                        <Tooltip placement="top" title="Сгенерировать билеты">
                                                                            <IconButton size="small" onClick={this.generateDialogOpen(this, base.BaseID)}>
                                                                                <Description/>
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                        <Tooltip placement="top" title="Просмотр сгенерированных билетов">
                                                                            <IconButton size="small" onClick={() => { window.open(`/tickets/${base.BaseID}`) }}>
                                                                                <Folder/>
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                        {
                                                                            (base.content.creator.id === this.props.user.EmployeeID || this.props.user.AccessLevel < 3) ?
                                                                                <Tooltip placement="top" title={"Удалить базу вопросов"}>
                                                                                    <IconButton size="small" aria-label="delete" onClick={this.deleteBase(this, base.BaseID)}>
                                                                                        <Close />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                                : null
                                                                        }

                                                                    </ListItemSecondaryAction>
                                                                </ListItem>
                                                            </List>
                                                            <Divider />
                                                            <CardContent style={{}}>
                                                                <Typography variant="subtitle1" color="textSecondary" component="h6">
                                                                    <span>{"Разделы"}
                                                                        {
                                                                            (base.content.creator.id === this.props.user.EmployeeID || this.props.user.AccessLevel < 3) ?
                                                                                <Tooltip placement="right" title={"Создать раздел с вопросами"}>
                                                                                    <IconButton style={{ marginLeft: "2px", marginTop: "-2px" }} size="small" onClick={this.uploadFileDialogOpen(this, base.BaseID)}>
                                                                                        <AddCircle />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                                : null
                                                                        }

                                                                    </span>
                                                                </Typography>
                                                                <List>
                                                                    {base.content.sections ? base.content.sections.map((section, index) => {
                                                                        return (
                                                                            <Paper style={{ marginTop: "8px" }}>
                                                                                <ListItem >
                                                                                    <ListItemIcon>
                                                                                        <Typography style={{ width: "100%" }} variant="h6" color="textSecondary" component="h6">
                                                                                            {section.id}
                                                                                        </Typography>
                                                                                    </ListItemIcon>
                                                                                    <ListItemText
                                                                                        style={{ textOverflow: "ellipsis", marginLeft: "-10px" }}
                                                                                        primary={'Использовать: ' + section.getForGeneration + ''}
                                                                                        secondary={"из: " + section.count + " вопросов"}
                                                                                    />
                                                                                    <ListItemSecondaryAction>
                                                                                        {
                                                                                            (base.content.creator.id === this.props.user.EmployeeID || this.props.user.AccessLevel < 3) ?
                                                                                                <Fragment><Tooltip placement="top" title={"Редактировать раздел"}>
                                                                                                    <IconButton size="small" aria-label="edit" onClick={this.previewDialogOpen(this, base.BaseID, section.id)}>
                                                                                                        <Edit />
                                                                                                    </IconButton>
                                                                                                </Tooltip>
                                                                                                    <Tooltip placement="top" title={"Удалить раздел"}>
                                                                                                        <IconButton size="small" aria-label="delete" onClick={this.deleteQuestion(this, base.BaseID, section.id)}>
                                                                                                            <Close />
                                                                                                        </IconButton>
                                                                                                    </Tooltip></Fragment> : null
                                                                                        }
                                                                                    </ListItemSecondaryAction>
                                                                                </ListItem>

                                                                            </Paper>
                                                                        )
                                                                    }) : null}
                                                                </List>
                                                                <br />
                                                                <Typography variant="subtitle1" color="textSecondary" component="h6">
                                                                    Для специальностей
                                                                </Typography>
                                                                <List>
                                                                    {
                                                                        base.content.specialties ? base.content.specialties.map(specialty => {
                                                                            return (
                                                                                <Paper style={{ marginTop: "8px" }}>
                                                                                    <ListItem >
                                                                                        <ListItemText
                                                                                            primary={specialty.SpecialtyName}
                                                                                            secondary={specialty.SpecialtyCode}
                                                                                        />

                                                                                        <ListItemSecondaryAction>
                                                                                            {(base.content.creator.id === this.props.user.EmployeeID || this.props.user.AccessLevel < 3) ?
                                                                                                <Tooltip placement="top" title={"Удалить специальность"}>
                                                                                                    <IconButton size="small" aria-label="delete" onClick={this.deleteSpecialty(this, base.BaseID, specialty.SpecialtyID)}>
                                                                                                        <Close />
                                                                                                    </IconButton>
                                                                                                </Tooltip>
                                                                                                : null
                                                                                            }

                                                                                        </ListItemSecondaryAction>
                                                                                    </ListItem>
                                                                                </Paper>
                                                                            )
                                                                        }) : null
                                                                    }
                                                                </List>

                                                                {(base.content.creator.id === this.props.user.EmployeeID || this.props.user.AccessLevel < 3) ?
                                                                    <Fragment>
                                                                        <Typography style={{ textAlign: "center", width: "100%" }} variant="caption" color="textSecondary" component="div">
                                                                            <div>Перетащите специальность сюда</div><ArrowDownward />
                                                                        </Typography>
                                                                        <Droppable droppableId={base.BaseID.toString()}>
                                                                            {(provided, snapshot) => (


                                                                                <RootRef rootRef={provided.innerRef}>
                                                                                    <List>

                                                                                    </List>
                                                                                    {provided.placeholder}
                                                                                </RootRef>

                                                                            )}
                                                                        </Droppable>
                                                                    </Fragment>
                                                                    : null}
                                                            </CardContent>
                                                        </Card>
                                                    </Grid>
                                                )
                                            })}
                                        </Grid>
                                    </Container>
                                    {/* </Paper> */}
                                </Grid>
                            </Grid>
                        </Container>
                    </DragDropContext>
                </Fragment>

                <Dialog open={this.state.createBaseDialogIsOpen} onClose={this.dialogClose(this)} aria-labelledby="form-dialog-title">
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="baseName"
                            label="Имя базы вопросов"
                            type="text"
                            fullWidth
                        />
                        
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.dialogClose(this)} color="secondary">
                            Отмена
                    </Button>
                        <Button onClick={this.createBase(this)} color="primary">
                            Создать
                    </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={this.state.uploadFileDialogIsOpen} onClose={this.dialogClose(this)} aria-labelledby="form-dialog-title">
                    <DialogTitle id="alert-dialog-title">{"Создание раздела с вопросами"}</DialogTitle>
                    <DialogContent>

                        <DialogContentText id="alert-dialog-description">
                            Необходимо загрузить файл в формате <strong style={{ color: "black" }}>.docx</strong> или <strong style={{ color: "black" }}>.doc</strong><br /> Вопросы должны быть разделены символом <strong style={{ color: "black" }}>#</strong> (решетка)<br /><br />
                        </DialogContentText>
                        <div style={{ textAlign:'center', display: this.state.fileLoading ? 'block' : 'none' }}>
                            <Typography>{this.state.loaderText}</Typography>
                            <LinearProgress color="primary" />
                        </div>
                        <div style={{ flexGrow: 1, height: "100px" }}>
                            <Button
                                variant="contained"
                                component="label"
                                color="primary"
                                disabled={this.state.fileLoading}
                                style={{ marginTop: "4%", marginLeft: "32%", backgroundColor: "rgb(62,102,161)" }}
                            // onClick={this.handleButtonClick}
                            >
                                <CloudUpload />
                                <p style={{ marginLeft: "10px" }}>{'Загрузить'}</p>
                                <input
                                    onChange={e => this.uploadFile(e.target.files[0])}
                                    style={{ display: 'none' }}
                                    type="file"
                                    accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword"
                                />
                            </Button>
                        </div>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.dialogClose(this)} color="secondary">
                            Отмена
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={this.state.previewDialog} onClose={this.dialogClose(this)} scroll="paper" fullWidth={true} maxWidth="md" >
                    <DialogTitle>
                        {"Брать вопросов из раздела: " + (this.state.currentQuestion ? this.state.currentQuestion.getForGeneration : '')}
                        <br />
                        {
                            this.state.currentQuestion ? 
                            <Slider
                            defaultValue={this.state.currentQuestion.getForGeneration}
                            aria-labelledby="discrete-slider"
                            valueLabelDisplay="auto"
                            step={1}
                            marks
                            min={1}
                            max={this.state.currentQuestion.questions.length}
                        
                            onChangeCommitted={(e,v) => this.editCountQuestion(this.state.currentQuestion.id, v)}
                        />
                            : null
                        }
                    </DialogTitle>
                    <DialogContent dividers={true} style={{ backgroundColor: "rgb(235, 236, 240)" }}>
                        <List>
                            {
                                this.state.currentQuestion ?
                                    this.state.currentQuestion.questions.map((q) => {
                                        return (
                                            <Paper style={{ marginTop: "8px" }}>
                                                <ListItem>
                                                    <ListItemIcon>
                                                        <Typography style={{ width: "100%" }} variant="h6" color="textSecondary" component="h6">
                                                            {q.id}
                                                        </Typography>
                                                    </ListItemIcon>
                                                    <div id={'q' + q.id} dangerouslySetInnerHTML={{ __html: q.content }}>
                                                    </div>
                                                </ListItem>
                                            </Paper>
                                        )
                                    })
                                    : null
                            }
                        </List>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.dialogClose(this)} color="secondary">
                            Готово
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={this.state.generateDialogIsOpen} onClose={this.dialogClose(this)} aria-labelledby="form-dialog-title">
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="ticketCount"
                            label="Количество билетов"
                            type="number"
                            fullWidth
                        />
                        <div style={{ textAlign:'center', display: this.state.generating ? 'block' : 'none' }}>
                            <Typography>Идет генерация...</Typography>
                            <LinearProgress color="primary" />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.dialogClose(this)} color="secondary">
                            Отмена
                    </Button>
                        <Button onClick={this.generateTickets(this)} color="primary">
                            Сгенерировать
                    </Button>
                    </DialogActions>
                </Dialog>

            </Fragment>
        )
    }


    createBaseDialogOpen(context) {
        return () => {
            context.setState({
                createBaseDialogIsOpen: true
            })
        }
    }

    uploadFileDialogOpen(context, baseid) {
        return () => {
            context.baseid = baseid
            context.setState({
                uploadFileDialogIsOpen: true
            })
        }
    }

    generateDialogOpen(context, baseid) {
        return () => {
            context.baseid = baseid
            context.setState({
                generateDialogIsOpen: true
            })
        }
    }

    previewDialogOpen(context, baseid, questionid) {
        return async () => {

            try {
                const result = await context.api.call('get.question', { baseid, questionid })
                this.baseid = baseid
                context.setState({
                    currentQuestion: result,
                    previewDialog: true
                })

            } catch (error) {
                alert(await error.json())
                context.setState({
                    currentQuestion: null,
                    previewDialog: false
                })

            }
        }
    }

    dialogClose(context) {
        return () => {
            context.baseid = 0
            context.setState({
                generateDialogIsOpen: false,
                createBaseDialogIsOpen: false,
                uploadFileDialogIsOpen: false,
                previewDialog: false
            })
        }

    }

    async editCountQuestion(questionid, value) {

        try {
            const res = await this.api.call('edit.count', { baseid: this.baseid, questionid }, { count: value })
            const result = await this.api.call('get.question', { baseid: this.baseid, questionid })

            this.setState({
                currentQuestion: result
            })

            this.getBaseList()
        } catch (error) {
            alert(await error.json())
            this.baseid = 0
            this.setState({
                currentQuestion: null,
                previewDialog: false,
            })
        }

    }

    async uploadFile(file) {
        console.log(this.baseid, file)

           try {
            this.setState({
                fileLoading: true
            })

            // const result = await this.api.call('add.question', { baseid: this.baseid }, question, true)
            // console.log(result)
            // this.baseid = 0
            console.log('Подготовка к загрузке...')
            this.setState({ loaderText: 'Подготовка к загрузке...' })
            const token = await this.api.getGoogleToken()
            
            this.googleapi.setToken(token.token)
            console.log('Загрузка файла')
            this.setState({ loaderText: 'Загрузка файла' })
            const uploadResult = await this.googleapi.upload(file)
            console.log('Получение конвертированного файла')
            this.setState({ loaderText: 'Получение конвертированного файла' })
            const htmlPage = await this.googleapi.download(uploadResult.id)
            console.log(uploadResult.id)
            console.log('Идет трансформация содержимого')
            this.setState({ loaderText: 'Идет трансформация содержимого' })
            const transformedPage = await htmlTransformer(htmlPage, token.token)
            const deleteResult = await this.googleapi.delete(uploadResult.id)
            console.log('Создание списка вопросов')
            this.setState({ loaderText: 'Создание списка вопросов' })

            const questionArray = transformedPage.split(/(?:<\w+(?:[^>]*)>)+[ ]*#[ ]*(?:<\/\w+>)+/).map((value, index) => {
                return {
                    id : index + 1,
                    content: value
                }
            })

            console.log('Загрузка списка вопросов на сервер')
            this.setState({ loaderText: 'Загрузка списка вопросов на сервер' })
            const result = await this.api.call('add.question', { baseid: this.baseid }, { question: questionArray })
            console.log(result)

            this.getBaseList()

            this.setState({
                loaderText: '',
                createBaseDialogIsOpen: false,
                uploadFileDialogIsOpen: false,
                fileLoading: false
            })

        } catch (error) {
            alert(await error)

            this.baseid = 0
            this.setState({
                loaderText: '',
                createBaseDialogIsOpen: false,
                uploadFileDialogIsOpen: false,
                fileLoading: false
            })
        }


    }

    generateTickets(context) {
        return async () => {
            const ticketCount = document.getElementById('ticketCount').value

            try {
                context.setState({
                    generating: true
                })

                //const token = await this.api.getGoogleToken()
                const response = await context.api.call('get.generatedtickets', { baseid: this.baseid, count: ticketCount, token: 'blalbla' })
                
                const a = document.createElement('a');
                //a.target = "blank"
                a.href = 'http://' + window.location.hostname + response.url
                a.click()

                context.setState({
                    generateDialogIsOpen: false,
                    generating: false
                })
            } catch (error) {
                alert(error)
            }
        }
    }


    createBase(context) {
        return async () => {
            const baseName = document.getElementById('baseName').value

            try {
                if (baseName.length == 0) { alert("Имя не должно быть пустым"); return }
                await context.api.call('add.base', { disciplineid: context.disciplineid, languageid: context.languageid }, { baseName })
                context.getBaseList()
                context.setState({
                    createBaseDialogIsOpen: false
                })
            } catch (error) {
                alert(await error.json())
            }
        }
    }


    deleteBase(context, baseid) {
        return async () => {
            try {
                await context.api.call('delete.base', { baseid })
                context.componentWillMount()
            } catch (error) {
                alert(await error.json())
            }
        }
    }

    deleteSpecialty(context, baseid, specialtyid) {
        return async () => {
            try {
                await context.api.call('delete.specialty', { baseid, specialtyid })
                context.componentWillMount()
            } catch (error) {
                alert(await error.json())
            }
        }
    }

    deleteQuestion(context, baseid, questionid) {
        return async () => {
            try {
                await context.api.call('delete.question', { baseid, questionid })
                context.componentWillMount()
            } catch (error) {
                alert(await error.json())
            }
        }
    }

    onDragEnd(context) {
        return async (result) => {
            console.log(result)
            if (!result.destination) {
                return
            } else if (result.destination.droppableId === "droppable") {
                return
            } else if (isNaN(result.destination.droppableId)) {
                return
            }

            const specialties = context.state.specialties
            const specialty = specialties.find((s) => s.SpecialtyID === parseInt(result.draggableId))
            const index = specialties.findIndex((s) => s.SpecialtyID === parseInt(result.draggableId))

            specialties.splice(index, 1)

            this.setState({
                specialties
            })

            try {
                await context.api.call('add.specialty', { baseid: parseInt(result.destination.droppableId) }, specialty)
                context.componentWillMount()
            } catch (error) {
                alert(await error.json())
                context.componentWillMount()
            }

        }

    }

    getSpecialtyList() {

        this.api.call('get.undistributedSpecialty', { disciplineid: this.disciplineid, languageid: this.languageid }).then((result) => {
            this.setState({ specialties: result })
        }).catch((err) => {
            this.setState({ specialties: [] })
            //alert(err)
            //this.props.history.replace('/editor');
        });
    }

    getBaseList() {
        this.api.call('get.baseList', { disciplineid: this.disciplineid, languageid: this.languageid }).then((result) => {
            this.setState({ baseList: result })
        }).catch((err) => {
            this.setState({ baseList: [] })
        });
    }





}



export default withStyles(styles)(withAuth(BaseEditorDiscipline))


